import { IPhoneNumber } from '../types/reducers/offer';

export const getPhone = (phoneObject: IPhoneNumber | null | undefined): string | null => {
  if (!phoneObject) {
    return null;
  }

  return `${phoneObject.countryCode}${phoneObject.number}`;
};
